<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Skills"><skills></skills></mat-tab>
  <mat-tab label="Training"><training></training></mat-tab>
  <mat-tab label="Volunteer Dept"><voldepartment></voldepartment></mat-tab>
  <mat-tab label="Qualifications"><qualifications></qualifications></mat-tab>
  <mat-tab label="Positions"><positions></positions></mat-tab>
</mat-tab-group>
 